module.exports = __webpack_public_path__ + "img/Type12Insert_I_small2-min.7662e210.png";